
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CircleIcon from './CircleIcon.vue';
import TagIcon from './TagIcon.vue';

@Component({
  name: 'TagLetterIcon',
  components: {
    CircleIcon,
    TagIcon
  }
})
export default class TagLetterIcon extends Vue {
  @Prop({ default: '#ffdc00' })
  private tagColor: string;

  @Prop({ default: '#0a6dc4' })
  private letterColor: string;

  @Prop({ default: 'tag_default_icon' })
  private tag: string;

  @Prop({ default: '#000' })
  private tagFill: string;

  @Prop()
  private letter: string;
}
